export const Bluebanner = () => {
    return (
        <div className="rorepair" id="bluebanner">
            <div className="container">
                <h1>RO Repair in Patna</h1>
                <p>
                    Ensuring access to clean, safe drinking water is vital for every home and business in Patna. At RO Care Repair, we offer dependable RO repair services designed to keep your water purification systems running efficiently and effectively.
                </p>

            </div>
        </div>
    )
} 